import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { VideoEmbeder } from '../../../VideoEmbeder';

const PainPointSection = ({ openModal }) => {
    const { t } = useTranslation();

    return (
        <section className="py-5 bg-white">
            <Container>
                <Row className="justify-content-center align-items-center">
                    <Col xs={12} lg={6} className="mb-4 mb-lg-0">
                        <h4>{t('pages.dmarcChecker.painPoint.title')}</h4>
                        <p dangerouslySetInnerHTML={{ __html: t('pages.dmarcChecker.painPoint.body1') }} />
                        <hr />
                        <h5>{t('pages.dmarcChecker.painPoint.title2')}</h5>
                        <p dangerouslySetInnerHTML={{ __html: t('pages.dmarcChecker.painPoint.body2') }} />
                        <h5>{t('pages.dmarcChecker.painPoint.title3')}</h5>
                        <p dangerouslySetInnerHTML={{ __html: t('pages.dmarcChecker.painPoint.body3') }} />
                        <div className="d-flex flex-column flex-md-row gap-3 mt-4">
                            <Button variant="primary" size="lg" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                {t('pages.dmarcChecker.painPoint.scanMyDomainNow')}
                            </Button>
                            <Button variant="warning" size="lg" onClick={openModal}>
                                {t('pages.dmarcChecker.painPoint.bookACall')}
                            </Button>
                        </div>
                    </Col>
                    <Col xs={12} lg={6} className="d-flex justify-content-center">
                        <VideoEmbeder videoId="WpyK6VOf5LE" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default PainPointSection;
